export const FONT_FAMILIES = [
  {
    imagePath: '/static/images/fonts/noto_sans.png',
    value: 'notosans',
  },
  {
    imagePath: '/static/images/fonts/ap.png',
    value: 'ap',
  },
  {
    imagePath: '/static/images/fonts/anko.png',
    value: 'anko',
  },
  {
    imagePath: '/static/images/fonts/smart_ui.png',
    value: 'smartfont',
  },
]
export type FONT_FAMILY = (typeof FONT_FAMILIES)[number]
export type FONT_FAMILY_VALUE = (typeof FONT_FAMILIES)[number]['value']
